import React from 'react';
import DataGrid from '@dataGrid';
import GridConfig from './GridConfig';
import { compose } from 'recompose';
import { withSnackbar } from 'notistack';
import styles from './styles';
import { withStyles } from '@material-ui/core';
import StatusBar from '@dataGrid/components/StatusBar';
import GridHeader from './GridHeader';
import { csvFormulaInjectionSanitizer } from '../../../../../../utilities/csvUtils';
import Events from '../../../../../../utilities/EventEmitter';
import appConstants from '../../../../../../appConstants';

class PriorityShipmentsGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      quickFilterText: '',
      isPrintingInProgress: false,
      panelFilter: 'All'
    };
    this.gridConfig = new GridConfig();
    this.gridApi = null;
  }

  onGridReady = ({ api }) => {
    this.gridApi = api;
    this.gridApi.runCommand = this.runCommand;
  };

  exportCSV = () => {
    if (!this.isDataAvailable()) {
      return;
    }
    const columnIds = this.gridApi.getColumns().reduce((columnKeys, column) => {
      if (column.colDef.headerName) {
        columnKeys.push(column.colId);
      }
      return columnKeys;
    }, []);
    const params = {
      fileName: `${this.props.displayKpiName || this.props.kpiName}_Shipments`,
      columnKeys: columnIds,
      processCellCallback: (cell) => csvFormulaInjectionSanitizer(cell.value)
    };
    this.gridApi.exportDataAsCsv(params);
  };

  updateQuickFilterText = (searchText) => {
    this.setState({
      quickFilterText: searchText
    });
  };

  isDataAvailable = () => {
    if (!this.props.priorityShipments.length || !this.gridApi) {
      this.props.enqueueSnackbar('No data to download', {
        variant: 'error'
      });
      return false;
    }
    return true;
  };

  doesExternalFilterPass = (node) => {
    let doesFilterPass;
    if (this.state.panelFilter === 'Pending') {
      doesFilterPass = !node.data.isCompleted;
    } else if (this.state.panelFilter === 'Completed') {
      doesFilterPass = node.data.isCompleted;
    } else {
      doesFilterPass = true;
    }
    return doesFilterPass;
  };

  panelFilterChanged = (filter) => {
    this.setState(
      {
        panelFilter: filter
      },
      () => this.gridApi.onFilterChanged?.()
    );
  };

  constructStatusBar = (filteredData) => {
    const statusBarData = [
      {
        label: this.props.priorityShipments?.length + ` Total ${this.props.displayKpiName || this.props.kpiName}`,
        filterCondition: 'All'
      },
      {
        label: filteredData.filter((shipment) => !shipment.isCompleted).length + ' Pending',
        filterCondition: 'Pending'
      },
      {
        label: filteredData.filter((shipment) => shipment.isCompleted).length + ' Completed',
        filterCondition: 'Completed'
      }
    ];
    return statusBarData;
  };

  runCommand = (command, props) => {
    if (command === 'showDriver') {
      let pageName = '';
      if (window.location.pathname !== appConstants.NAV_URLS.DISPATCH_ROUTEEXECUTION) {
        pageName = appConstants.NAV_URLS.DISPATCH_ROUTEEXECUTION;
      }
      Events.emit('onDriverSelectInKPI', pageName, [props.driverId], props.stopId);
      this.props.onCloseModel();
    }
  };

  render() {
    const { priorityShipments = [], classes, onCloseModel, kpiName, displayKpiName } = this.props;
    const { quickFilterText, panelFilter } = this.state;
    return (
      <div className={classes.container} id="priority-shipments">
        <GridHeader
          exportCSV={this.exportCSV}
          title={`${displayKpiName || kpiName} Shipments`}
          updateQuickFilterText={this.updateQuickFilterText}
          onCloseModel={onCloseModel}
          kpiName={kpiName}
          gridApi={this.gridApi}
        />
        <div className={classes.dataGrid}>
          <DataGrid
            defaultColDef={this.gridConfig.config.defaultColDef}
            columnDefs={this.gridConfig.config.columns}
            config={this.gridConfig.config}
            rowData={priorityShipments}
            onSelectionChanged={this.onSelectionChanged}
            panelLabel={(filteredData) => (
              <StatusBar
                data={this.constructStatusBar(filteredData)}
                filterGridData={this.panelFilterChanged}
              />
            )}
            isExternalFilterPresent={() => Boolean(panelFilter)}
            doesExternalFilterPass={this.doesExternalFilterPass}
            quickFilterText={quickFilterText}
            onGridReady={this.onGridReady}
            showErrorMessage={this.props.gridErrorMessage}
          />
        </div>
      </div>
    );
  }
}
export default compose(withSnackbar, withStyles(styles))(PriorityShipmentsGrid);
